<template>
  <v-container fill-height>
    <v-row align="center" justify="center" class="hidden-xs-only">
      <v-col cols="6" sm="3" lg="6" class="hidden-xs-only">
        <v-img src="/img/login_img.png"></v-img>
      </v-col>

      <v-col cols="12" xs="12" sm="4" lg="5">
        <v-container fluid>
          <v-row no-gutters>
            <v-col align="center">
              <v-card tile flat>
                <v-card-title
                  class="title font-weight-bold font-weight-black font-italic black--text justify-center"
                  >Login</v-card-title
                >

                <v-divider></v-divider>

                <v-card-text>
                  <v-form @submit.prevent="login" v-model="validForm">
                    <v-text-field
                      label="Username"
                      prepend-icon="mdi-account"
                      v-model="username"
                      :rules="[notEmptyRule('Username')]"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                    <v-text-field
                      label="Password"
                      prepend-icon="mdi-lock"
                      type="password"
                      autocomplete="off"
                      v-model="password"
                      :rules="[notEmptyRule('Password')]"
                      filled
                      rounded
                      dense
                    ></v-text-field>

                    <v-btn
                      color="primary"
                      type="submit"
                      :loading="btnLoading"
                      :disabled="!validForm"
                      rounded
                      >Login</v-btn
                    >
                  </v-form>

                  <div class="ma-2 subtitle-2">
                    <a href="/forgot-password" class="black--text">
                      <i>Forgot Password</i>
                    </a>
                  </div>

                  <div class="ma-2 subtitle-2">
                    <a href="/account/recover" class="black--text">
                      <i>I lost access to my Authenticator device</i>
                    </a>
                  </div>

                  <v-divider></v-divider>

                  <div class="subtitle-2 grey--text text--darken-2 mt-2">
                    This site is protected by reCAPTCHA and the Google
                    <a href="https://policies.google.com/privacy"
                      >Privacy Policy</a
                    >
                    and
                    <a href="https://policies.google.com/terms"
                      >Terms of Service</a
                    >
                    apply.
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbarError" :timeout="5000" top right color="error">
      <span>{{ snackbarMessage }}</span>
      <v-btn
        text
        color="white"
        @click="
          {
            snackbarError = false
            snackbarMessage = ''
          }
        "
        >Close</v-btn
      >
    </v-snackbar>
  </v-container>
</template>

<script>
import { TokenService } from '@/services/storage.service'
import ApiService from '@/services/api.service'
export default {
  name: 'home',
  data() {
    return {
      username: '',
      password: '',
      snackbarError: false,
      snackbarMessage: '',
      btnLoading: false,
      notEmptyRule(property) {
        return v => (v && v.length > 0) || `${property} cannot be empty.`
      },
      validForm: false
    }
  },
  methods: {
    async login() {
      let username = this.username
      let password = this.password
      this.btnLoading = true

      ApiService.post('/login', { username, password }).then(res => {
        if (res.data.success) {
          TokenService.saveToken(res.data.respond.token)
          this.btnLoading = false
          this.$router.push({ name: 'Dashboard' })
        } else {
          this.btnLoading = false
          this.$swal('', res.data.error, 'error')
        }
      })
    }
  }
}
</script>

<style scoped>
.v-card {
  /* border: 4px solid #6200ea; */
  border-radius: 20px;
  background-image: url('/img/cool-background.png');
}
</style>
